




















































































import Element from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  ExpertData, emptyExpert, ExpertProfessionData
} from '@/api/systemManage/user'
import { validateIntKey, validatePhone } from '@/configs/validate'
import { copyArray } from '@/configs/functions'
import {
  DDLItem,
  DefDDLItem,
  getCityByProvince
} from '@/api/common/select'
import { enLookupType, enFirstType } from '@/configs/enums'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    ExpertType: [
      {
        required: true,
        validator: validateIntKey('请选择专家类型'),
        trigger: 'change'
      }
    ],
    // Education: [{ required: true, validator: validateIntKey('请选择学历'), trigger: 'change' }],
    // PositionalTitleId: [{ required: true, validator: validateIntKey('请选择职称'), trigger: 'change' }],
    BirthDate: [
      { required: true, message: '请选择专家出生年月', trigger: 'blur' }
    ],
    ContactorPhone: [
      // { required: true, message: '手机不能为空', trigger: 'blur' },
      { validator: validatePhone, trigger: 'blur' }
    ]
  }
}

@Component
export default class ExpertInfo extends Vue {
  public name: string = 'ExpertInfo'
  @Prop({ default: false })
  public readonly: boolean = false

  public form: ExpertData = Object.assign({}, emptyExpert)
  public firstType = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public rules = getFormRules(0, this.form)
  public expertTypeList: DDLItem[] = []
  public educationList: DDLItem[] = []
  public positionalList: DDLItem[] = []
  public provinceList: DDLItem[] = []
  public cityList: DDLItem[] = [this.defItem]
  public professionList: DDLItem[] = []

  public get selectedProfessions(): number[] {
    const f = this.form
    const vals = f.ProfessionList.map((data: ExpertProfessionData) => {
      return data.ProfessionalTechId
    })
    return vals
  }
  public set selectedProfessions(vals: number[]) {
    const f = this.form
    const objs: ExpertProfessionData[] = vals.map((data: number) => {
      return {
        Id: 0,
        ExpertId: f.Id,
        ProfessionalTechId: data,
        ProfessionalName: ''
      }
    })
    f.ProfessionList = objs
  }

  // dynamic component
  public $refs!: {
    expertForm: Element.Form
  }
  public getForm() {
    return this.$refs.expertForm
  }
  public getData() {
    const f = this.form
    return f
  }
  @DataSourceModule.Getter('unitClassify')
  public unitClassify!: any
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public setData(info: ExpertData) {
    var unitClassify = copyArray(this.unitClassify)
    if (unitClassify) {
      unitClassify.splice(0, 1)
      this.professionList = unitClassify
    }
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.expertTypeList = data.expertTypeList
      this.educationList = data.educationList
      this.positionalList = data.positionalList
      this.provinceList = data.provinceList
    }

    if (info.Id > 0) {
      this.fetchCity()
      this.form = info
    }
    this.rules = getFormRules(this.form.Id, this.form)
    if (this.form.Id == 0) {
      this.$nextTick(() => {
        if (this.$refs.expertForm) {
          this.$refs.expertForm.clearValidate()
        }
      })
    }
  }
  public fetchCity() {
    const f = this.form
    if (f.ProvinceId > 0) {
      //加载市级
      getCityByProvince(f.ProvinceId, this.firstType).then(
        (response: { data: any }) => {
          this.cityList = response.data
        }
      )
    }
  }
}
